import i18n from "../../../i18n";

import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";

import DateService from "../../../services/dateService";
import SelectFieldService from "../../../services/selectFieldService";
import SyncIcon from "@mui/icons-material/Sync";

export const EQUIPMENT_SCHEME_TABLE_CONFIG = [
  {
    name: "equipment_nr",
    getValueCallback: (rowData) => rowData.equipment_nr,
    label: i18n.t("table.counter_repository.equipment_nr"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipscheme_user",
    getValueCallback: (rowData) => rowData.equipscheme_user,
    label: i18n.t("table.counter_repository.equipscheme_user"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "tenant",
    getValueCallback: (rowData) => rowData.tenant,
    label: i18n.t("table.counter_repository.tenant"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipscheme_scripts",
    getValueCallback: (rowData) => rowData.equipscheme_scripts,
    label: i18n.t("table.counter_repository.equipscheme_scripts"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipscheme_start",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD(
        rowData.equipscheme_start,
      ),
    label: i18n.t("table.counter_repository.equipscheme_start"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipscheme_end",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD(
        rowData.equipscheme_end,
      ),
    label: i18n.t("table.counter_repository.equipscheme_end"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipscheme_active",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(rowData.equipscheme_active),
    label: i18n.t("table.counter_repository.equipscheme_active"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edit",
    getValueCallback: (rowData, onClickEdit) => (
      <ModeEditOutlineOutlined onClick={(e) => onClickEdit(rowData.id)} />
    ),
    label: i18n.t("edit"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
    getFilterFieldConfigCallback: (filteringData) => undefined,
    allowChangeVisibility: false,
    excludedFromExport: true,
  },
  {
    name: "recalculate_usage",
    getValueCallback: (rowData, onClickEdit, onClickRecalculate) => (
      <SyncIcon onClick={(e) => onClickRecalculate(rowData.id)} />
    ),
    label: i18n.t("recalculate_usage"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
    getFilterFieldConfigCallback: (filteringData) => undefined,
    allowChangeVisibility: false,
    excludedFromExport: true,
  },
  {
    name: "recalculate_ed",
    getValueCallback: (
      rowData,
      onClickEdit,
      onClickRecalculateUsage,
      onClickRecalculateEd,
    ) => <SyncIcon onClick={(e) => onClickRecalculateEd(rowData.id)} />,
    label: i18n.t("recalculate_ed"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
    getFilterFieldConfigCallback: (filteringData) => undefined,
    allowChangeVisibility: false,
    excludedFromExport: true,
  },
];
